import React from 'react'
// import { Routes, Route } from "react-router-dom"
// import { Link } from 'react-router-dom';
// import { BrowserRouter } from "react-router-dom"
import Navbar from '../Components/Navbar';
import Footer from '../Components/Footer'




const Devprojects = () => {
  return (
    <div>
      

      <Navbar />
      
      
      
      <h2>Devprojects</h2>

      <p>I am an empty page</p>
 
      <Footer />

    </div>
  )
}

export default Devprojects